import axios from 'axios'
import { logout } from '@config/auth/services/authService'
import { EnvironmentVariable } from './constants'
import { auth } from '../config/auth/firebaseConfig'

const { localEnvConfig } = EnvironmentVariable

const HTTPInstance = axios.create({
  baseURL: localEnvConfig.API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTPInstance.interceptors.request.use(async config => {
  const user = auth.currentUser
  if (user) {
    const token = await user.getIdToken()
    if (config.headers) {
      config.headers.set('Authorization', `Bearer ${token}`)
    }
  }
  return config
})

HTTPInstance.interceptors.response.use(
  res => res,
  async error => {
    const { response, config } = error || {}

    if (
      response?.status === 401 &&
      auth.currentUser &&
      config &&
      !config.isRetry
    ) {
      try {
        ;(config as unknown as { isRetry: boolean }).isRetry = true
        const fresh = await auth.currentUser.getIdToken(true)

        if (config.headers) {
          config.headers.set('Authorization', `Bearer ${fresh}`)
        }
      } catch {
        // fall through to logout below
      }
    }

    if (response?.status === 401) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('restaurantId')
      await logout()
    }

    return Promise.reject(error)
  }
)

export { HTTPInstance }
